// extracted by mini-css-extract-plugin
export default {"recipeTitleImage":"G730f5c","recipeImage":"G905101","recipeTitle":"G63a5c4","recipeRadioButtonGroup":"G55f476"};